import { ThunderboltOutlined } from '@ant-design/icons'

export default {
  id: 'statement',
  routerPrefix: '/statement',
  icon: ThunderboltOutlined,
  reactRoot: () => import('.')
}
